import { FC } from "react";
import { ICustomerBill, PosInfoSectionMode } from "../../../typings";
import Cart from "./cart/cart";
import Insight from "./insights/insight";

export interface IInfoSectionProps {
  mode?: PosInfoSectionMode;
  editingBillId?: string;
}

const InfoSection: FC<IInfoSectionProps> = ({
  mode = PosInfoSectionMode.CART,
  editingBillId,
}) => {
  return (
    <>
      {mode === PosInfoSectionMode.CART && !editingBillId && <Cart />}

      {mode === PosInfoSectionMode.CART && editingBillId && (
        <Cart editingBillId={editingBillId} />
      )}

      {mode === PosInfoSectionMode.INSIGHT && <Insight />}
    </>
  );
};

export default InfoSection;
